import * as z from "zod";
import {
  AreasFieldLocationFormDataSchema,
  AttachmentFieldFormDataSchema,
  ContractDetailsFormDataSchema,
  ReviewSchema,
  UsersSchema,
  VisitDetailsSchemaFormDataSchema,
} from "@/pages/requests/components";
import { VisitDetailsField } from "@/pages/requests/components/visit-details-form/types";
import { UsersField } from "@/pages/requests/components/users/types";

export const validationSchema = (subStep: string) => {
  const users = UsersSchema(subStep) as z.ZodTypeAny;

  const usersValidator = z.any().superRefine((data, ctx) => {
    const d = data as Record<string, unknown>;

    // Run original users validation and forward issues
    if (users) {
      const parsed = users.safeParse(d);

      if (!parsed.success) {
        for (const issue of parsed.error.issues) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: issue.path,
            message: issue.message,
          });
        }
      }
    }

    // Apply cross-field rule only when personnel step exists and subStep === 'a'
    // We can't call hooks here; UsersSchema returned optional when personnel step missing,
    // so skip only when users schema is optional empty object (no rules).
    if (subStep !== "a") {
      return;
    }

    const noVehicles = !d[VisitDetailsField.NumberOfVehicles];
    const noCameras = !d[VisitDetailsField.NumberOfCameras];
    const noVessels = !d[VisitDetailsField.NumberOfVessels];

    const usersVal = d[UsersField.Users];

    const noUsers =
      !Array.isArray(usersVal) || (usersVal as unknown[]).length === 0;

    if (noVehicles && noCameras && noVessels && noUsers) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [UsersField.Users],
        message:
          "Please select at least one person when no vehicles, photography permits, or vessels are requested.",
      });
    }
  });

  return [
    ContractDetailsFormDataSchema,
    VisitDetailsSchemaFormDataSchema,
    usersValidator,
    AreasFieldLocationFormDataSchema,
    AttachmentFieldFormDataSchema(),
    ReviewSchema,
  ];
};
